module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/about-ba015c7955fdfa58cb44170b55b099e3.jpg";